import React, { useEffect, useRef } from "react";
import CountUp from "react-countup";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

const joiningData = [
  { value: 200, suffix: "+", label: "Politics Enthusiasts" },
  { value: 50, suffix: "%", label: "Decision Makers" },
  { value: 10, suffix: "+", label: "Countries Represented" },
  { value: 20, suffix: "+", label: "Sessions" },
];

const JoiningUs = () => {
  const numberRefs = useRef([]);

  useEffect(() => {
    // Adding ScrollTrigger to animate the numbers when they come into view
    numberRefs.current.forEach((numberRef, index) => {
      gsap.fromTo(
        numberRef,
        {
          scale: 0.5, // Start with a smaller scale
          opacity: 0, // Start with opacity 0
          y: 50, // Start from a bit lower
        },
        {
          scale: 1, // End with normal scale
          opacity: 1, // Fade in
          y: 0, // Move to its original position
          duration: 1,
          delay: index * 0.3, // Stagger the animations slightly
          ease: "power3.out", // Use a smooth easing
          scrollTrigger: {
            trigger: numberRef, // Element to trigger the animation
            start: "top 80%", // Trigger when the element is 80% from the top of the viewport
            end: "top 30%", // End the trigger when the element is 30% from the top of the viewport
            scrub: true, // Make the animation scrubbed based on scroll position
            once: true, // Only trigger once when the element enters the viewport
          },
          onComplete: () => {
            // Add a "bounce" effect after the number appears
            gsap.to(numberRef, {
              scale: 1.1,
              duration: 0.2,
              yoyo: true,
              repeat: 1,
            });
          },
        }
      );
    });
  }, []);

  return (
    <div className="bg-brandBlue mb-[5rem] xs:mb-[3rem] flex flex-col font-outfit items-center">
      <div className="mt-[5rem] xxs:mt-[3rem]  h-[0.0625rem] relative w-[80%] m-auto gradient-divider"></div>

      <h3 className="text-center uppercase tracking-[0.2rem] text-white text-[1.3125rem] xxs:text-lg xs:text-lg py-[4.375rem]">
        Who is joining us
      </h3>
      <div className="flex justify-between flex-wrap px-[9.0635rem] gap-x-[6.875rem] gap-y-[4.875rem]">
        {joiningData.map((item, index) => (
          <div key={index} className="min-w[12.5rem]">
            <h2
              ref={(el) => (numberRefs.current[index] = el)} // Assigning refs to each number
              className="text-[3.125rem] leading-[3.125rem] font-[900] text-gradient"
            >
              <CountUp end={item.value} duration={3} />
              <span>{item.suffix}</span>
            </h2>
            <p className="text-[1.375rem] mt-[1.25rem] font-medium text-white whitespace-nowrap">
              {item.label}
            </p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default JoiningUs;
